import { Paginacion } from "../paginacion/paginacion.model";

export interface CotizacionRequest {
  paginacion: Paginacion;
  cdAgente: string;
  cdUsuario: string;
  fechaCreacionInicio: string;
  fechaCreacionFin: string;
  nroCotizacion: string;
  dniTomador: string;
  cdRamo: string;
  cdSubramo: string;
  cdCanal: string;
}

export class CotizacionRequestBuilder {
  private readonly _cotizacionRequest: CotizacionRequest;

  constructor() {
    this._cotizacionRequest = {
      paginacion: {
        pagina: 0,
        filasPorPagina: 40,
        columnaOrdenamiento: "fechaCotizacion",
        direccionOrdenamiento: -1,
      } as Paginacion,
      cdAgente: null,
      cdUsuario: null,
      fechaCreacionInicio: null,
      fechaCreacionFin: null,
      nroCotizacion: null,
      dniTomador: null,
      cdRamo: null,
      cdSubramo: null,
      cdCanal: null,
    };
  }

  paginacion(paginacion: any): CotizacionRequestBuilder {
    this._cotizacionRequest.paginacion = paginacion;
    return this;
  }

  cdAgente(cdAgente: string): CotizacionRequestBuilder {
    this._cotizacionRequest.cdAgente = cdAgente;
    return this;
  }

  cdUsuario(cdUsuario: string): CotizacionRequestBuilder {
    this._cotizacionRequest.cdUsuario = cdUsuario;
    return this;
  }

  fechaCreacionInicio(fechaCreacionInicio: string): CotizacionRequestBuilder {
    this._cotizacionRequest.fechaCreacionInicio = fechaCreacionInicio;
    return this;
  }

  fechaCreacionFin(fechaCreacionFin: string): CotizacionRequestBuilder {
    this._cotizacionRequest.fechaCreacionFin = fechaCreacionFin;
    return this;
  }

  nroCotizacion(nroCotizacion: string): CotizacionRequestBuilder {
    this._cotizacionRequest.nroCotizacion = nroCotizacion;
    return this;
  }

  dniTomador(dniTomador: string): CotizacionRequestBuilder {
    this._cotizacionRequest.dniTomador = dniTomador;
    return this;
  }

  cdRamo(cdRamo: string): CotizacionRequestBuilder {
    this._cotizacionRequest.cdRamo = cdRamo;
    return this;
  }

  cdSubramo(cdSubramo: string): CotizacionRequestBuilder {
    this._cotizacionRequest.cdSubramo = cdSubramo;
    return this;
  }

  cdCanal(cdCanal: string): CotizacionRequestBuilder {
    this._cotizacionRequest.cdCanal = cdCanal;
    return this;
  }

  build(): CotizacionRequest {
    return this._cotizacionRequest;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/cotizacion/cotizacion-request.model.ts